import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cw5lqh1hd4: FaireBrandEntity = {
  token: "b_cw5lqh1hd4",
  type: "brand",
  name: "Simplified Soap",
  avatarUrl:
    "https://cdn.faire.com/fastly/692aadc1613ca601dda1c73720fb52fcdbe49fc2b01733a65c1ee92b885cbf04.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c2013eefdce5e42684bcc7a01a5a87a402055227381f57ebdb71aa7d7966c3b7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/692aadc1613ca601dda1c73720fb52fcdbe49fc2b01733a65c1ee92b885cbf04.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c2013eefdce5e42684bcc7a01a5a87a402055227381f57ebdb71aa7d7966c3b7.png",
  location: "Seadrift, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 422,
  isTopShop: true,
  isInsider: true,
  description:
    "IT ALL STARTED WHEN...\n\nBack in February of 2013 I decided to wean our youngest and put her on cow’s milk. We had no idea that she was allergic to it and she broke out in a full-body rash. Well crap. \n\nI did a little researching on options and we settled on goat’s milk after reading that many people who are intolerant to cow’s milk proteins can happily down goat’s milk all day long. The milk we bought at our beloved H-E-B tasted like wet shoes so we decided to buy our first milk goat. We found Sarah, a beautiful dark Nubian dairy goat who was already in milk. A few YouTube videos later and we were milking away!\n\nFast forward a few months——————>\nI had been buying handmade goat milk soap from a lady who sold it at a Market Days (outdoor shopping) nearby. Market Days is only once a month ‘round here and she didn’t show up two months in a row. I know - the nerve of this lady to have something else to do that day. Just kidding.....sort of.\n\nMy #1 has got ridiculously sensitive skin that breaks out in a full-body rash when coming in contact with common chemicals that most of us can tolerate. Since goat milk soap is all she can use, goat milk soap was gettin’ made. Back to YouTube I go.\n\nWelp -  things happened. I found I liked making soap. My house smelled great, my skin rejoiced, and creative juices were flowing. Turns out there are a lot of people I know that have sissy la la skin that needed to ditch the Dial. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:34.589Z",
    importedBy: "entity-db-cli",
  },
};
